import {applyMiddleware, combineReducers, createStore} from "redux";

import thunk from "redux-thunk";
import {authReducer} from "./auth/auth-reducer";
import {userReducer} from "./user/user-reducer";
import {dataReducer} from "./data/data-reducer";
import {logbookReducer} from "./logbook/logbook-reducer";
import {profileReducer} from "./profile/profile-reducer";
import {LOGOUT} from "./auth/auth-types";
import {notificationsReducer} from "./notifications/notifications-reducer";


let reducers = combineReducers({
  authReducer,
  userReducer,
  dataReducer,
  logbookReducer,
  profileReducer,
  notificationsReducer
})

let rootReducer = (state, action) => {
  if(action.type === LOGOUT) {
    state = undefined
  }
  return reducers(state, action)
}

let store = createStore(rootReducer, applyMiddleware(thunk))
export default store
